import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ServiceError } from '@app/shared/models/dtos/response.dto';

@Component({
  selector: 'app-error-snackbar',
  templateUrl: './error-snackbar.component.html',
  styleUrls: ['./error-snackbar.component.sass'],
})
export class ErrorSnackbarComponent {
  constructor(public sbRef: MatSnackBarRef<ErrorSnackbarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: ServiceError[]) {}
}
